import { PublicationInfoTableProps } from "/Models/Generated/PublicationInfoTableProps";
import "./PublicationInfoTable.scss";
import cn from "classnames";
import { PublicationInfoTableItemProps } from "/Models/Generated/PublicationInfoTableItemProps";

const PublicationInfoTable = ({
  heading,
  headingPropertyName,
  title,
  published,
  publicationType,
  carriedOutBy,
  commissionedBy,
  area,
  theme,
  numberOfPages,
  serialNumber,
  isbn,
  issn,
  projectNumber,
  bottomText,
}: PublicationInfoTableProps) => {
  const tableRow = ({
    name,
    value,
    propertyName,
  }: PublicationInfoTableItemProps) =>
    value || propertyName ? (
      <tr>
        <td>{name}</td>
        <td
          className={cn({ "epi-editContainer": propertyName })}
          data-epi-property-name={propertyName}
        >
          {value}
        </td>
      </tr>
    ) : null;

  return (
    <div className="publication-info-table-norad">
      {(heading || headingPropertyName) && (
        <h2
          className={cn("publication-info-table-norad__heading", {
            "epi-editContainer": headingPropertyName,
          })}
          data-epi-property-name={headingPropertyName}
        >
          {heading}
        </h2>
      )}
      <table>
        <tbody>
          {title && tableRow(title)}
          {published && tableRow(published)}
          {publicationType && tableRow(publicationType)}
          {carriedOutBy && tableRow(carriedOutBy)}
          {commissionedBy && tableRow(commissionedBy)}
          {area && tableRow(area)}
          {theme && tableRow(theme)}
          {numberOfPages && tableRow(numberOfPages)}
          {serialNumber && tableRow(serialNumber)}
          {isbn && tableRow(isbn)}
          {issn && tableRow(issn)}
          {projectNumber && tableRow(projectNumber)}
        </tbody>
      </table>
      {bottomText && (
        <p className="publication-info-table-norad__bottom-text">
          {bottomText}
        </p>
      )}
    </div>
  );
};

export default PublicationInfoTable;
